import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab, Card, CardContent, Typography, Button } from '@mui/material';
import { List, ListItem, ListItemText } from '@mui/material';
import { Skeleton, Container } from '@mui/material';
import { fetchSubscriptionsData, fetchTrainingsData, registerTransaction } from './api';
import TrainingModal from './TrainingModal';
import handlePayment from './payment.js';
import { sub } from 'date-fns';

const Subscriptions = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const place_id = 1;
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedTraining, setSelectedTraining] = useState(null);
  const [trainings, setTrainings] = useState([]);

  useEffect(() => {
    fetchSubscriptionsData(place_id)
      .then((data) => setSubscriptions(data))
      .catch((error) => console.error('Error fetching subscriptions:', error));
  }, []);

  useEffect(() => {
    fetchTrainingsData(place_id)
      .then((data) => setTrainings(data))
      .catch((error) => console.error('Error fetching trainings:', error));
  }, []);

  const handleOpenDialog = (training) => {
    setSelectedTraining(training);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedTraining(null);
    setOpenDialog(false);
  };

  const handleTabChange = (event, newTab) => {
    setSelectedTab(newTab);
  };

  const purchase = async (subscription) => {
    const token = localStorage.getItem('token');
    try {
      const orderData = await registerTransaction(token, subscription.price);
      const { id: paymentId, order_id: orderId } = orderData;
      handlePayment(paymentId, subscription, orderId);
    } catch (error) {
      console.error('Ошибка при регистрации транзакции:', error);
    }
  };
  if ('True') {
    return (
      <div>
        <h1>Тренировки</h1>
        <p>Модуль с тренировками находится в разработке</p>
      </div>
    );
  }

  if (!subscriptions && !trainings) {
    return (
      <Container sx={{ marginTop: '100px' }}>
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
      </Container>
    );
  }

  return (
    <Box>
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        centered
      >
        <Tab label='Абонементы' />
        <Tab label='Тренировки' />
      </Tabs>
      <Box p={3}>
        {selectedTab === 0 && (
          <Box>
            {subscriptions.map((subscription) => (
              <Card
                key={subscription.id}
                sx={{ mb: 2 }}
              >
                <CardContent>
                  <Typography variant='h6'>{subscription.subscription_name}</Typography>
                  <Typography
                    variant='body2'
                    color='textSecondary'
                  >
                    {subscription.info}
                  </Typography>
                  <Typography variant='body2'>
                    {subscription.coach_name} {subscription.rank}
                  </Typography>
                  <Typography
                    variant='body1'
                    sx={{ mt: 2 }}
                  >
                    Цена: {subscription.price} ₽
                  </Typography>
                  <Typography variant='body1'>
                    Количество тренировок: {subscription.quantity}
                  </Typography>
                  <Button onClick={() => purchase(subscription)}> Приобрести </Button>
                </CardContent>
              </Card>
            ))}
            <div id='button_container'></div>
          </Box>
        )}
        {selectedTab === 1 && (
          <List>
            {trainings.map((training) => (
              <ListItem
                key={training.id}
                button
                onClick={() => handleOpenDialog(training)}
              >
                <ListItemText
                  primary={training.subscription_name}
                  secondary={training.info}
                />
                <Typography variant='body2'>
                  {' '}
                  {training.players} / {training.quantity}{' '}
                </Typography>
              </ListItem>
            ))}
          </List>
        )}
        <TrainingModal
          open={openDialog}
          onClose={handleCloseDialog}
          training={selectedTraining}
        />
      </Box>
    </Box>
  );
};

export default Subscriptions;
